import { Reducer } from '@reduxjs/toolkit'

import {
  CREATE_WAITING_CUSTOMER_SUCCESS,
  DELETE_WAITING_CUSTOMERS_SUCCESS,
  EXTRA_ACTIVITIES_LOADING,
  GET_EXTRA_ACTIVITIES,
  GET_MENU_CATEGORIES_SUCCESS,
  GET_WAITING_CUSTOMERS_FAILURE,
  GET_WAITING_CUSTOMERS_SUCCESS,
  MENU_LOADING,
  SET_LOADING_TRUE,
  UNDO_DELETE_WAITING_CUSTOMERS_SUCCESS,
  UPDATE_WAITING_CUSTOMERS_FAILURE,
  UPDATE_WAITING_CUSTOMERS_SUCCESS,
} from './Actions'
import IWaitingListState from './IWaitingListState'

const initialState: IWaitingListState = {
  isLoading: false,
}

// TODO type waitingList actions
export const waitingListReducer: Reducer<IWaitingListState, any> = (
  state = initialState,
  action,
) => {
  switch (action.type) {
    case SET_LOADING_TRUE:
      return {
        ...state,
        isLoading: true,
      }

    case GET_WAITING_CUSTOMERS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        waitingCustomers: action.waitingCustomers,
      }

    case CREATE_WAITING_CUSTOMER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        waitingCustomers: [...state.waitingCustomers, action.waitingCustomer],
      }
    case GET_WAITING_CUSTOMERS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.message,
      }

    case DELETE_WAITING_CUSTOMERS_SUCCESS:
      const deleteIndex = state.waitingCustomers.findIndex(
        waitingCustomer => waitingCustomer.id === action.waitingCustomer.id,
      )

      if (-1 === deleteIndex) {
        return state
      }

      const deletedCustomer = {
        ...state.waitingCustomers[deleteIndex],
        isDeleted: true,
      }

      return {
        ...state,
        waitingCustomers: [
          ...state.waitingCustomers.slice(0, deleteIndex),
          deletedCustomer,
          ...state.waitingCustomers.slice(deleteIndex + 1),
        ],
      }

    case UNDO_DELETE_WAITING_CUSTOMERS_SUCCESS:
      const undoDeleteIndex = state.waitingCustomers.findIndex(
        waitingCustomer => waitingCustomer.id === action.waitingCustomer.id,
      )

      if (-1 === undoDeleteIndex) {
        return state
      }

      const undoDeletedCustomer = {
        ...state.waitingCustomers[undoDeleteIndex],
        isDeleted: false,
      }

      return {
        ...state,
        waitingCustomers: [
          ...state.waitingCustomers.slice(0, undoDeleteIndex),
          undoDeletedCustomer,
          ...state.waitingCustomers.slice(undoDeleteIndex + 1),
        ],
      }
    case UPDATE_WAITING_CUSTOMERS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        waitingCustomers: action.waitingCustomers,
      }
    case UPDATE_WAITING_CUSTOMERS_FAILURE:
      return {
        ...state,
        isLoading: false,
      }
    case EXTRA_ACTIVITIES_LOADING:
      return {
        ...state,
        isLoading: true,
      }
    case GET_EXTRA_ACTIVITIES:
      return {
        ...state,
        isLoading: false,
        activityList: action.payload.categories,
      }
    case MENU_LOADING:
      return {
        ...state,
        isLoading: true,
      }
    case GET_MENU_CATEGORIES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        menuList: action.categories,
      }
    default:
      return state
  }
}
